export default __webpack_public_path__ + "static/media/Logo-Zaivu.fb2d9071.svg";